import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// 2024斋月greedyRecharge页面信息 http://wiki.xunlei.cn/pages/viewpage.action?pageId=132030025
export const greedyRechargePage = createAsyncThunk(
  '/live/activity/greedy_recharge_page',
  async (arg: any, store: any) => {
    const resp = await http.post('/live/activity/greedy_recharge_page', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return {
      ...resp.data.data,
    }
  }
)
interface InitialStateType {
  greedy_recharge_page?: {
    bet_targets?: Array<any> // 下注目标置
    bet_tokens?: Array<number> // 下注金额配置
    recharge_coins?: number // 已充值金币数
    game_tokens?: number // 当前游戏币数
    is_first_visit?: boolean // 是否首次访问
    notices?: Array<any> // 中奖播报
  }
}

const initialState: InitialStateType = {
  greedy_recharge_page: {},
}

export const GreedyRechargeSlice = createSlice({
  name: 'GreedyRecharge',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(greedyRechargePage.fulfilled, (state, action) => {
      Object.assign(state.greedy_recharge_page, action.payload)
    })
  },
})
export default GreedyRechargeSlice.reducer
